var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAssign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_227_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20 40c11.046 0 20-8.9543 20-20 0-11.046-8.9543-20-20-20-11.046 0-20 8.9543-20 20 0 11.046 8.9543 20 20 20z",
    fill: "#0CA5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 15.033c2.0676 0 3.7436-1.6902 3.7436-3.7751 0-2.0849-1.676-3.7751-3.7436-3.7751-2.0675 0-3.7436 1.6902-3.7436 3.7751 0 2.0849 1.6761 3.7751 3.7436 3.7751z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6781
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.508 18.709c-.5627-.232-1.1794-.3598-1.8268-.3598h-5.1796c-2.6625 0-4.806 2.1615-4.806 4.8464v5.7333c0 .7349.5866 1.3264 1.3153 1.3264h12.161c.7286 0 1.3152-.5915 1.3152-1.3264v-1.5256",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6781
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.001 16.936 2.0833 2.0876-6.4702 6.4836-2.3725.2899.2891-2.3775 6.4703-6.4836z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6781
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.947 18.994 2.0832 2.0876",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6781
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_227_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAssign);
export default __webpack_public_path__ + "static/media/icon_assign.1bf991ae1f4c0fab4edbd2e2e95c49e7.svg";
export { ForwardRef as ReactComponent };